import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { SpaLoadPeriodDTO } from '@api';

@Component({
  selector: 'spa-report-spa-bar-chart-capacity',
  templateUrl: './report-bar-chart-capacity.component.html',
  styleUrls: ['./report-bar-chart-capacity.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportBarChartCapacityComponent {
  @Input() timeLoad: SpaLoadPeriodDTO | undefined;

  @Input() isHovered = false;

  // Stacked-segment base fills.
  presentFill = getComputedStyle(document.documentElement).getPropertyValue('--forest-100');
  presentFillHover = getComputedStyle(document.documentElement).getPropertyValue('--slate-400');
  bookedFill = getComputedStyle(document.documentElement).getPropertyValue('--forest-700');
  slotsFill = getComputedStyle(document.documentElement).getPropertyValue('--slate-400');
  slotsFillHover = getComputedStyle(document.documentElement).getPropertyValue('--slate-300');

  // On hover, the booked segment reveals the occupancy traffic-light: plenty free is green,
  // filling up is amber, nearly full is alert red, ended periods are greyed.
  manyAvailableHover = getComputedStyle(document.documentElement).getPropertyValue('--forest-300');
  someAvailableHover = getComputedStyle(document.documentElement).getPropertyValue('--warning-300');
  lessAvailableHover = getComputedStyle(document.documentElement).getPropertyValue('--error-300');
  pastHover = getComputedStyle(document.documentElement).getPropertyValue('--slate-300');
}
